export default __webpack_public_path__ + "static/media/leader.2d89c531.svg";